// import color from "../../../constants/color";

import color from "../../../../../constants/color"

const styles = {

  TableHead: {
    color: "#878787",
    fontWeight: "400",
  },

  leaveHeading: { 
    fontWeight: 600,
    fontSize: "20px", 
    pb:1
  },

  userName: { 
    fontWeight: 600,
    fontSize: "20px", 
  },

  tabledata: {
    borderBottom: 0,
    textTransform:"capitalize"

  },
  tableAvtardata: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center",
  },

  tableActiondata: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center", 
  },
  dropdown:{
    "& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":{
      padding:"8.5px 14px"

    },
    width:"29.2em"
  },
  reason:{
    borderRadius: "8px",

    width:"100%",
    mt: 1,
    height: "4.5em",},
  name:{
    color:color.text,
    fontSize:"14px",
    fontWeight:"400",
    textTransform:"capitalize"
  
  },
  mail:{
    color:color.lightText,
    fontSize:"14px",
    fontWeight:"400"
  },  
  label:{
    fontSize:"12px",
    fontWeight:"500" ,
    color:color.text
  },
  profile: {
    mr: 1,

  },
  filterButton:{ display:"flex",
    backgroundColor:color.secondary,
    color:color.card,
    borderRadius:"30px",
    // width:{ xs: "50%", md: "20%" },
    marginLeft:{ xs: 0, md: "8px" },
    alignItems:"center",
    paddingRight:2,
    mb:{ xs: "20px", md: 0 },
    
  },
  icon:{
    fill:color.lightText,
    mr:1,
    width: "14px",
    height: "14px",
    display: "flex",
  },
  popup: {
    borderRadius: "10%", 
    border: "1px solid #E5E5E5"
  },
  iconSvg: {
    "svg" :{
      fill:color.lightText,
      mr:1,
      width: "14px",
      height: "14px",
      display: "flex",
  
    },
  },
  iconGrid:{
    display: "flex", 
    alignItems: "center",
    mb:1
  },
  iconText: {
    fontSize: "12px",

  },
  filterContainer:{
    position:"relative"
  },
  StatBox: {
    backgroundColor: color.secondary,
    borderRadius: "20px",
    p: 2,
    mb:{ xs:2, md: 2 ,lg: 0},
  },
  invoiceBox: {
    backgroundColor: color.card,
    borderRadius: "20px",
    p: 2,
    mb:{ xs:2, md: 2 ,lg: 0},
  },
  profileSection: {
    display: "flex",
    justifyContent: "space-between"
  },
  profileGrid: {
    display:"flex",
    alignItems: "center"
  },
  invoiceHeading: {
    fontSize: "14px",
    fontWeight: "500",
    color: color.primary,
  },
  checkoutBtn: {
    borderRadius: 50, 
    backgroundColor: "#28AA4A",
    color: "#fff", 
    ml: "8px",
    textTransform: "none",
    fontSize: "12px",
    boxShadow:"none"
  },

  totalText: {
    color: color.card,
    fontSize: "16px",
    fontWeight: "500",
  },
  invoiceText: {
    fontSize: "16px",
    fontWeight: "500",
    mb:2
  },
  avatar: {
    height: "25px",
    width: "25px",
    mr: "4px",
  },

  totalCount: {
    fontSize: "28px",
    fontWeight: "600",
    color: color.card,
    mt:1
  },
  StatBoxfirst: {
    display: "flex",
    alignItems:"center",
    justifyContent: "center",
    backgroundColor: color.card,
    borderRadius: "20px",
    p: "10px",
    mb:{ xs:2, md: 2 ,lg: 0},

  },

  StatBoxs: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: color.card,
    borderRadius: "20px",
    p: "10px",
    mr: 1,
    mb:{ xs:2, md: 2 ,lg: 0},

  },
  cards: {
    mt: 2
  },
  paygrid:{
    display: "flex", 
    alignItems: "center", 
    justifyContent: "space-between",
    mt: 2,
  },
  iconSection: {
    backgroundColor: color.secondary,
    borderRadius: "50%",
    mr:3,
    width: "45px",
    height: "45px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

  },
  TiconSection: {
    backgroundColor: color.primary,
    borderRadius: "50%",
    mr:3,
    width: "45px",
    height: "45px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

  },

  QiconSection: {
    backgroundColor: "#F4B63F",
    borderRadius: "50%",
    mr:3,
    width: "45px",
    height: "45px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

  },
  EiconSection: {
    backgroundColor: "#E93030",
    borderRadius: "50%",
    mr:3,
    width: "45px",
    height: "45px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

  },


  exportbtn: {
    borderRadius: 50, 
    textTransform: "none" , 
    backgroundColor: color.secondary,
    mr: "10px", 
    // my: 4,
    fontSize: "12px",
    px: 3,

  },
  emailIcon: {
    mr: 1, 
  },

  downloadIcon: {
    mr: 1, 
  },
  downloadbtn: {
    borderRadius: 50, 
    textTransform: "none" , 
    backgroundColor: "#28AA4A",
    // ml: { xs: 0, md: "10px" }, 
    my: 4,
    fontSize: "12px",
  },
  paybtn: {
    borderRadius: 50, 
    textTransform: "none" , 
    backgroundColor: "#28AA4A",
    ml: { xs: 0, md: "10px" }, 
    fontSize: "12px",
  },


  gridContainer: {
    px:"15px",
    pt:"7px",
    pb:"25px",
    display: "flex",
    justifyContent:"space-between", 
  },
  gridText: {
    px:"15px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"

  },
  cardBox: {
    display:"flex",
    alignItems: "center",
    my:3,
  },
  monthlyText: {
    color: color.lightText,
    fontSize: "12px",
    fontWeight: "500",

  },
  monthlyHeading: {
    fontSize: "18px",
    fontWeight: "700",

  },

  expandIcon: {
    color: color.lightText,
    display: "flex",
    
 
  },
  cardTitle: {
    color: color.text ,
    fontWeight:"700",
    fontSize:"18px"
  },
  cardSubtitle:
  { color: color.lightText,
    fontWeight: "400",
    fontSize: "12px" 
  },

  cardSubtitles:
  { color: color.lightText,
    fontWeight: "500",
    fontSize: "12px" 
  },


}
export default styles
